const Home = () => import('../views/Home.vue')

export default [
  {
    path: 'entity',
    component: Home,
    meta: { requiresAuth: true },
    alias: ['home', '']
  }
]